<section class="spacer-pt-space spacer-pb-space bg-black">
    <div class="container">
        <div class="flex flex-wrap md:flex-nowrap md:gap-[68px] md:mb-[88px] flex-col-reverse md:flex-row">
            <div class="intro-text overflow-hidden max-w-full md:max-w-[50%] md:!mb-0">
                <h2 class="heading-primary-8xl text-white mb-5 md:mb-6">{{data.title1}}</h2>
                <div class="editor-content *:xl:text-16 *:xxl:text-18 text-white  relative h-full contentAreaLeft"
                    [innerHTML]="data.desc1"></div>
            </div>
            <div class="max-w-full md:max-w-[50%]">
                <img [ngSrc]="assetsCDNUrl+data.imageUrl1" class="h-auto mb-5 md:mb-0" alt="{{data.title1}}" width="518"
                    height="275" loading="lazy" />
            </div>
        </div>
        <div class="flex flex-wrap md:flex-nowrap md:gap-[68px]">
            <div class="max-w-full md:max-w-[50%]">
                <img [ngSrc]="assetsCDNUrl+data.imageUrl2" class="h-auto mb-5 md:mb-0" alt="{{data.title2}}" width="518"
                    height="275" loading="lazy" />
            </div>
            <div class="intro-text overflow-hidden max-w-full md:max-w-[50%] !mb-0">
                <h2 class="heading-primary-8xl text-white text-right mb-5 md:mb-6">{{data.title2}}</h2>
                <div class="editor-content text-white text-right *:xl:text-16 *:xxl:text-18 h-full  relative contentAreaRight"
                    [innerHTML]="data.desc2"></div>
            </div>
        </div>
    </div>
</section>